





































































import Errors from '@/utils/Errors';

import ErrorInfoModalButton from '@/components/modals/ErrorInfoModalButton.vue';
import MarkdownContent from '@/components/MarkdownContent.vue';
import Modal from '@/components/mixins/Modal';

interface Data {
    sentryId?: string;
}

export default Modal.extend({
    components: {
        ErrorInfoModalButton,
        MarkdownContent,
    },
    props: {
        error: {
            type: Error,
            required: true,
        },
    },
    data(): Data {
        return { sentryId: this.error.sentryId };
    },
    computed: {
        errorName(): string {
            return this.error.name || 'Error';
        },
        errorMessage(): string {
            return this.error.message || 'Unknown error';
        },
        stackTrace(): string {
            // TODO without sourcemaps this may not be so useful...
            const stack = this.error.stack || 'Stacktrace not found';

            return stack + '\n';
        },
        githubReportUrl(): string {
            const title = encodeURIComponent(`${this.errorName}: ${this.errorMessage}`);
            const body = encodeURIComponent(
                '[Please explain what you were trying to do when this error appeared.]\n\n' +
                'Stack trace:\n' +
                '```' + this.stackTrace + '```',
            );

            return `${this.$app.sourceUrl}/issues/new?title=${title}&body=${body}`;
        },
    },
    methods: {
        report() {
            if (this.sentryId) {
                this.$ui.showSnackbar('Sentry.io ID: ' + this.sentryId, { transient: true });

                return;
            }

            Errors.report(this.error);

            this.sentryId = this.error.sentryId;
            this.$ui.showSnackbar('Error reported to Sentry.io: ' + this.sentryId, { transient: true });
        },
        inspect() {
            (window as any).error = this.error;

            this.$ui.showSnackbar('You can now use the **error** variable in the console', { transient: true });
        },
        copy() {
            const textarea = document.createElement('textarea');
            textarea.value = `${this.errorName}: ${this.errorMessage}\n\n${this.stackTrace}`;
            textarea.style.position = 'fixed';
            textarea.style.top = '-9999px';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand('copy');
            textarea.remove();

            this.$ui.showSnackbar('Debug information copied to clipboard', { transient: true });
        },
    },
});
